import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Layout = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.s};
  flex-direction: column;

  > div {
    flex: 1;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0 0 ${(props) => props.theme.spacing.s};
  }

  .product-price {
    margin-bottom: ${(props) => props.theme.spacing.s};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.l};
    flex-direction: row;

    .product-price {
      margin-bottom: ${(props) => props.theme.spacing.m};
    }
  }
`;

export const Gallery = styled.div`
  position: relative;
`;

export const Section = styled.div<{ $large?: boolean }>`
  margin-bottom: ${(props) => props.theme.spacing.s};

  ${(props) =>
    props.$large &&
    css`
      margin-bottom: ${(props) => props.theme.spacing.m};

      @media (min-width: ${mobileBreakPointCSS}) {
        margin-bottom: ${(props) => props.theme.spacing.l};
      }
    `}
`;

export const AddToCart = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.s};
  flex-direction: column;

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.l};
    flex-direction: row;

    > button {
      flex: 1;
    }
  }
`;

export const ExpandableSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.l};
  }
`;

export const StyledExpandableSection = styled.div`
  background-color: var(--swatch4);
  color: var(--swatch2);
  border-top-right-radius: 50px;
  padding: ${(props) => props.theme.spacing.m};

  h2 {
    margin-bottom: 0;
  }

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: inherit;
    text-decoration: none;
  }

  svg {
    width: 16px;
    height: 16px;

    path {
      stroke: var(--swatch2);
    }
  }

  .rich-text {
    margin-top: ${(props) => props.theme.spacing.m};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.l};

    .rich-text {
      margin-top: ${(props) => props.theme.spacing.l};
    }
  }
`;
